export default __webpack_public_path__ + "static/media/cancel.7f109f94.svg";